import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-rs009-card-VI',
  templateUrl: './rs009-card-VI.component.html'
})

export class Rs009CardVIComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;

  @Output() objMakeCalculations = new EventEmitter();

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
    super('Espigas Atipicas e Morte Prematura', false);
    this.formulario = this.formBuilder.group({
      qnt_espiga_caixa: [null, []],
      espiga_atipica: [null, []],
      prc_espiga_atipica: [null, []],
      morte_prematura: [null, []],
      prc_morte_prematura: [null, []]
    });
  }

  async ngOnInit(): Promise<void> {

  }

  changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  calcEspigaAtipicas() {
    const qntEspiga = this.formulario.get('qnt_espiga_caixa');
    const espigaAtipica = this.formulario.get('espiga_atipica');
    console.log(espigaAtipica, qntEspiga);

    if (qntEspiga && espigaAtipica) {
      const qntEspigaValue = Number(qntEspiga.value);
      const espigaAtipicaValue = Number(espigaAtipica.value);

      if (!isNaN(qntEspigaValue) && !isNaN(espigaAtipicaValue) && qntEspigaValue > 0) {
        const getValue = (espigaAtipicaValue / qntEspigaValue) * 100;
        this.formulario.get('prc_espiga_atipica').setValue(getValue);
        console.log(getValue);
      }
    }
  }

  calcMortePrematura() {
    const qntEspiga = this.formulario.get('qnt_espiga_caixa');
    const mortePrematura = this.formulario.get('morte_prematura');
    console.log(mortePrematura, qntEspiga);

    if (qntEspiga && mortePrematura) {
      const qntEspigaValue = Number(qntEspiga.value);
      const mortePrematuraValue = Number(mortePrematura.value);

      if (!isNaN(qntEspigaValue) && !isNaN(mortePrematuraValue) && qntEspigaValue > 0) {
        const getValue = (mortePrematuraValue / qntEspigaValue) * 100;
        this.formulario.get('prc_morte_prematura').setValue(getValue);
        console.log(getValue);
      }
    }
  }
}

